<div class="modern-admin-page">
  <!-- Page Header -->
  <div class="page-header-card">
    <div class="header-content">
      <div class="page-title-section">
        <h1 class="page-title bangla-heading">ইউনিয়ন ব্যবস্থাপনা</h1>
        <p class="page-subtitle">ইউনিয়নের তথ্য, কর নির্ধারণ ও SMS সেটিংস পরিচালনা করুন</p>
      </div>
      <div class="page-actions">
        <button type="button" class="btn-secondary-modern" *ngIf="!editUnion" (click)="editForm()">
          <i class="fas fa-edit"></i>
          সম্পাদনা
        </button>
        <button type="button" class="btn-primary-modern" *ngIf="editUnion" (click)="saveForm()">
          <i class="fas fa-save"></i>
          সংরক্ষণ
        </button>
        <button type="button" class="btn-secondary-modern" *ngIf="editUnion" (click)="cancelForm()">
          <i class="fas fa-times"></i>
          বাতিল
        </button>
      </div>
    </div>
  </div>

  <div class="union-manage-container">
    <!-- Loading State -->
    <div *ngIf="isLoading" class="loading-state">
      <div class="loading-spinner">
        <i class="fas fa-spinner fa-spin"></i>
        <p class="bangla-text">ডেটা লোড হচ্ছে...</p>
      </div>
    </div>

    <form [formGroup]="unionFrom" class="modern-form" *ngIf="!isLoading">
      
      <!-- Basic Union Information -->
      <div class="content-card slide-up">
        <div class="card-header">
          <h3 class="card-title bangla-title">
            <i class="fas fa-info-circle"></i>
            মৌলিক তথ্য
          </h3>
          <div class="card-actions">
            <span class="info-badge bangla-text" *ngIf="!editUnion">
              <i class="fas fa-lock"></i>
              শুধুমাত্র পঠনযোগ্য
            </span>
            <span class="edit-badge bangla-text" *ngIf="editUnion">
              <i class="fas fa-edit"></i>
              সম্পাদনা মোড
            </span>
          </div>
        </div>
        
        <div class="card-body">
          <div class="form-row">
            <div class="form-group">
              <label class="form-label bangla-label required">
                <i class="fas fa-building"></i>
                ইউনিয়নের নাম
              </label>
              <input 
                type="text" 
                class="form-control-modern" 
                formControlName="union_name" 
                placeholder="ইউনিয়নের পূর্ণ নাম লিখুন"
                maxlength="100"
                [class.is-invalid]="isFieldInvalid('union_name')"
                [class.is-valid]="isFieldValid('union_name')">
              <div class="invalid-feedback" *ngIf="isFieldInvalid('union_name')">
                ইউনিয়নের নাম অবশ্যই লিখতে হবে
              </div>
              <div class="field-hint bangla-text">
                উদাহরণ: ডুমুরিয়া ইউনিয়ন পরিষদ
              </div>
            </div>
            
            <div class="form-group">
              <label class="form-label bangla-label required">
                <i class="fas fa-map-marker-alt"></i>
                উপজেলার নাম
              </label>
              <input 
                type="text" 
                class="form-control-modern" 
                formControlName="upozilla_name" 
                placeholder="উপজেলার নাম লিখুন"
                maxlength="50"
                [class.is-invalid]="isFieldInvalid('upozilla_name')"
                [class.is-valid]="isFieldValid('upozilla_name')">
              <div class="invalid-feedback" *ngIf="isFieldInvalid('upozilla_name')">
                উপজেলার নাম অবশ্যই লিখতে হবে
              </div>
              <div class="field-hint bangla-text">
                উদাহরণ: ডুমুরিয়া
              </div>
            </div>
            
            <div class="form-group">
              <label class="form-label bangla-label required">
                <i class="fas fa-globe-asia"></i>
                জেলার নাম
              </label>
              <input 
                type="text" 
                class="form-control-modern" 
                formControlName="zilla_name" 
                placeholder="জেলার নাম লিখুন"
                maxlength="50"
                [class.is-invalid]="isFieldInvalid('zilla_name')"
                [class.is-valid]="isFieldValid('zilla_name')">
              <div class="invalid-feedback" *ngIf="isFieldInvalid('zilla_name')">
                জেলার নাম অবশ্যই লিখতে হবে
              </div>
              <div class="field-hint bangla-text">
                উদাহরণ: খুলনা
              </div>
            </div>
          </div>

          <div class="form-row" *ngIf="canEditFinancialYear()">
            <div class="form-group full-width">
              <label class="form-label bangla-label required">
                <i class="fas fa-calendar-alt"></i>
                বর্তমান অর্থবছর
              </label>
              <div class="financial-year-wrapper">
                <select 
                  class="form-control-modern" 
                  formControlName="current_financial_year"
                  [class.is-invalid]="isFieldInvalid('current_financial_year')"
                  [class.is-valid]="isFieldValid('current_financial_year')">
                  <option value="" disabled>অর্থবছর নির্বাচন করুন</option>
                  <option *ngFor="let year of financialYearOptions" [value]="year">
                    {{ year }}-{{ year + 1 }} অর্থবছর
                  </option>
                </select>
                <div class="year-info">
                  <span class="current-year bangla-text" *ngIf="unionFrom.get('current_financial_year')?.value">
                    <i class="fas fa-check-circle"></i>
                    নির্বাচিত: {{ unionFrom.get('current_financial_year')?.value }}-{{ unionFrom.get('current_financial_year')?.value + 1 }}
                  </span>
                </div>
              </div>
              <div class="invalid-feedback" *ngIf="isFieldInvalid('current_financial_year')">
                অর্থবছর নির্বাচন করুন
              </div>
              <div class="form-note">
                <div class="note-content">
                  <i class="fas fa-exclamation-triangle"></i>
                  <div class="bangla-text">
                    <strong>গুরুত্বপূর্ণ:</strong> এই অর্থবছর সেট করা থাকলে নতুন এ্যাসেসমেন্ট তৈরি হওয়ার সাথে সাথে স্বয়ংক্রিয়ভাবে কর ক্রেডিট হবে।
                    <br><strong>উপলব্ধ রেঞ্জ:</strong> {{ financialYearOptions[0] }} - {{ financialYearOptions[financialYearOptions.length - 1] }}
                    <br><strong>প্রভাব:</strong> সব নতুন এ্যাসেসমেন্টে এই অর্থবছর প্রযোজ্য হবে
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Summary Stats -->
          <div class="info-summary" *ngIf="!editUnion">
            <div class="summary-item">
              <i class="fas fa-map-signs"></i>
              <div class="summary-content">
                <span class="summary-label bangla-text">সম্পূর্ণ ঠিকানা</span>
                <span class="summary-value bangla-text">
                  {{ unionFrom.get('union_name')?.value }}, 
                  {{ unionFrom.get('upozilla_name')?.value }}, 
                  {{ unionFrom.get('zilla_name')?.value }}
                </span>
              </div>
            </div>
            <div class="summary-item" *ngIf="unionFrom.get('current_financial_year')?.value">
              <i class="fas fa-calendar-check"></i>
              <div class="summary-content">
                <span class="summary-label bangla-text">সক্রিয় অর্থবছর</span>
                <span class="summary-value bangla-text">
                  {{ unionFrom.get('current_financial_year')?.value }}-{{ unionFrom.get('current_financial_year')?.value + 1 }}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- House Types and Tax Configuration -->
      <div class="content-card slide-up">
        <div class="card-header">
          <h3 class="card-title bangla-title">
            <i class="fas fa-home"></i>
            খানার ধরণ ও কর নির্ধারণ
          </h3>
          <div class="card-actions">
            <span class="house-types-count bangla-text">
              <i class="fas fa-calculator"></i>
              মোট {{ getConfiguredHouseTypesCount() }} টি ধরণ কনফিগার করা হয়েছে
            </span>
          </div>
        </div>
        
        <div class="card-body">
          <div class="house-types-help" *ngIf="editUnion">
            <div class="help-content">
              <i class="fas fa-info-circle"></i>
              <div class="bangla-text">
                <strong>নির্দেশনা:</strong> প্রতিটি খানার ধরণের জন্য আনুমানিক মূল্য ও ধার্যকৃত কর নির্ধারণ করুন। 
                মূল্য ও কর টাকায় লিখুন (যেমন: ১০০০০০)। খালি ঘর থাকলে সেই ধরণের খানা তৈরি করা যাবে না।
              </div>
            </div>
          </div>

          <div class="house-types-grid">
            
            <!-- Ek Chala -->
            <div class="house-type-item" [class.has-value]="hasHouseTypeValue('ek_chala')">
              <div class="house-type-header">
                <h4 class="bangla-title">এক চালা</h4>
                <div class="type-status">
                  <span class="status-badge" 
                        [class.active]="hasHouseTypeValue('ek_chala')"
                        [class.inactive]="!hasHouseTypeValue('ek_chala')">
                    <i class="fas" [class.fa-check]="hasHouseTypeValue('ek_chala')" 
                                   [class.fa-times]="!hasHouseTypeValue('ek_chala')"></i>
                    {{ hasHouseTypeValue('ek_chala') ? 'সক্রিয়' : 'নিষ্ক্রিয়' }}
                  </span>
                </div>
              </div>
              <div class="house-type-inputs">
                <div class="input-group">
                  <label class="bangla-label">
                    <i class="fas fa-tags"></i>
                    আনুমানিক মূল্য (টাকা)
                  </label>
                  <input 
                    type="text" 
                    class="form-control-modern number-input" 
                    formControlName="ek_chala" 
                    placeholder="০"
                    (input)="formatCurrency($event, 'ek_chala')"
                    [class.is-invalid]="isFieldInvalid('ek_chala')"
                    [class.is-valid]="isFieldValid('ek_chala')">
                  <div class="invalid-feedback" *ngIf="isFieldInvalid('ek_chala')">
                    সঠিক সংখ্যা লিখুন
                  </div>
                </div>
                <div class="input-group">
                  <label class="bangla-label">
                    <i class="fas fa-receipt"></i>
                    ধার্যকৃত কর (টাকা)
                  </label>
                  <input 
                    type="text" 
                    class="form-control-modern number-input" 
                    formControlName="ek_chala_kor" 
                    placeholder="০"
                    (input)="formatCurrency($event, 'ek_chala_kor')"
                    [class.is-invalid]="isFieldInvalid('ek_chala_kor')"
                    [class.is-valid]="isFieldValid('ek_chala_kor')">
                  <div class="invalid-feedback" *ngIf="isFieldInvalid('ek_chala_kor')">
                    সঠিক সংখ্যা লিখুন
                  </div>
                </div>
                <div class="tax-percentage" *ngIf="getTaxPercentage('ek_chala', 'ek_chala_kor') > 0">
                  <span class="percentage-info bangla-text">
                    <i class="fas fa-percent"></i>
                    কর হার: {{ getTaxPercentage('ek_chala', 'ek_chala_kor') }}%
                  </span>
                </div>
              </div>
            </div>

            <!-- Dui Chala -->
            <div class="house-type-item" [class.has-value]="hasHouseTypeValue('dui_chala')">
              <div class="house-type-header">
                <h4 class="bangla-title">দুই চালা</h4>
                <div class="type-status">
                  <span class="status-badge" 
                        [class.active]="hasHouseTypeValue('dui_chala')"
                        [class.inactive]="!hasHouseTypeValue('dui_chala')">
                    <i class="fas" [class.fa-check]="hasHouseTypeValue('dui_chala')" 
                                   [class.fa-times]="!hasHouseTypeValue('dui_chala')"></i>
                    {{ hasHouseTypeValue('dui_chala') ? 'সক্রিয়' : 'নিষ্ক্রিয়' }}
                  </span>
                </div>
              </div>
              <div class="house-type-inputs">
                <div class="input-group">
                  <label class="bangla-label">
                    <i class="fas fa-tags"></i>
                    আনুমানিক মূল্য (টাকা)
                  </label>
                  <input 
                    type="text" 
                    class="form-control-modern number-input" 
                    formControlName="dui_chala" 
                    placeholder="০"
                    (input)="formatCurrency($event, 'dui_chala')"
                    [class.is-invalid]="isFieldInvalid('dui_chala')"
                    [class.is-valid]="isFieldValid('dui_chala')">
                  <div class="invalid-feedback" *ngIf="isFieldInvalid('dui_chala')">
                    সঠিক সংখ্যা লিখুন
                  </div>
                </div>
                <div class="input-group">
                  <label class="bangla-label">
                    <i class="fas fa-receipt"></i>
                    ধার্যকৃত কর (টাকা)
                  </label>
                  <input 
                    type="text" 
                    class="form-control-modern number-input" 
                    formControlName="dui_chala_kor" 
                    placeholder="০"
                    (input)="formatCurrency($event, 'dui_chala_kor')"
                    [class.is-invalid]="isFieldInvalid('dui_chala_kor')"
                    [class.is-valid]="isFieldValid('dui_chala_kor')">
                  <div class="invalid-feedback" *ngIf="isFieldInvalid('dui_chala_kor')">
                    সঠিক সংখ্যা লিখুন
                  </div>
                </div>
                <div class="tax-percentage" *ngIf="getTaxPercentage('dui_chala', 'dui_chala_kor') > 0">
                  <span class="percentage-info bangla-text">
                    <i class="fas fa-percent"></i>
                    কর হার: {{ getTaxPercentage('dui_chala', 'dui_chala_kor') }}%
                  </span>
                </div>
              </div>
            </div>

            <!-- Char Chala -->
            <div class="house-type-item" [class.has-value]="hasHouseTypeValue('char_chala')">
              <div class="house-type-header">
                <h4 class="bangla-title">চার চালা</h4>
                <div class="type-status">
                  <span class="status-badge" 
                        [class.active]="hasHouseTypeValue('char_chala')"
                        [class.inactive]="!hasHouseTypeValue('char_chala')">
                    <i class="fas" [class.fa-check]="hasHouseTypeValue('char_chala')" 
                                   [class.fa-times]="!hasHouseTypeValue('char_chala')"></i>
                    {{ hasHouseTypeValue('char_chala') ? 'সক্রিয়' : 'নিষ্ক্রিয়' }}
                  </span>
                </div>
              </div>
              <div class="house-type-inputs">
                <div class="input-group">
                  <label class="bangla-label">
                    <i class="fas fa-tags"></i>
                    আনুমানিক মূল্য (টাকা)
                  </label>
                  <input 
                    type="text" 
                    class="form-control-modern number-input" 
                    formControlName="char_chala" 
                    placeholder="০"
                    (input)="formatCurrency($event, 'char_chala')"
                    [class.is-invalid]="isFieldInvalid('char_chala')"
                    [class.is-valid]="isFieldValid('char_chala')">
                  <div class="invalid-feedback" *ngIf="isFieldInvalid('char_chala')">
                    সঠিক সংখ্যা লিখুন
                  </div>
                </div>
                <div class="input-group">
                  <label class="bangla-label">
                    <i class="fas fa-receipt"></i>
                    ধার্যকৃত কর (টাকা)
                  </label>
                  <input 
                    type="text" 
                    class="form-control-modern number-input" 
                    formControlName="char_chala_kor" 
                    placeholder="০"
                    (input)="formatCurrency($event, 'char_chala_kor')"
                    [class.is-invalid]="isFieldInvalid('char_chala_kor')"
                    [class.is-valid]="isFieldValid('char_chala_kor')">
                  <div class="invalid-feedback" *ngIf="isFieldInvalid('char_chala_kor')">
                    সঠিক সংখ্যা লিখুন
                  </div>
                </div>
                <div class="tax-percentage" *ngIf="getTaxPercentage('char_chala', 'char_chala_kor') > 0">
                  <span class="percentage-info bangla-text">
                    <i class="fas fa-percent"></i>
                    কর হার: {{ getTaxPercentage('char_chala', 'char_chala_kor') }}%
                  </span>
                </div>
              </div>
            </div>

            <!-- Adha Paka -->
            <div class="house-type-item" [class.has-value]="hasHouseTypeValue('adha_paka')">
              <div class="house-type-header">
                <h4 class="bangla-title">আধা পাকা</h4>
                <div class="type-status">
                  <span class="status-badge" 
                        [class.active]="hasHouseTypeValue('adha_paka')"
                        [class.inactive]="!hasHouseTypeValue('adha_paka')">
                    <i class="fas" [class.fa-check]="hasHouseTypeValue('adha_paka')" 
                                   [class.fa-times]="!hasHouseTypeValue('adha_paka')"></i>
                    {{ hasHouseTypeValue('adha_paka') ? 'সক্রিয়' : 'নিষ্ক্রিয়' }}
                  </span>
                </div>
              </div>
              <div class="house-type-inputs">
                <div class="input-group">
                  <label class="bangla-label">
                    <i class="fas fa-tags"></i>
                    আনুমানিক মূল্য (টাকা)
                  </label>
                  <input 
                    type="text" 
                    class="form-control-modern number-input" 
                    formControlName="adha_paka" 
                    placeholder="০"
                    (input)="formatCurrency($event, 'adha_paka')"
                    [class.is-invalid]="isFieldInvalid('adha_paka')"
                    [class.is-valid]="isFieldValid('adha_paka')">
                  <div class="invalid-feedback" *ngIf="isFieldInvalid('adha_paka')">
                    সঠিক সংখ্যা লিখুন
                  </div>
                </div>
                <div class="input-group">
                  <label class="bangla-label">
                    <i class="fas fa-receipt"></i>
                    ধার্যকৃত কর (টাকা)
                  </label>
                  <input 
                    type="text" 
                    class="form-control-modern number-input" 
                    formControlName="adha_paka_kor" 
                    placeholder="০"
                    (input)="formatCurrency($event, 'adha_paka_kor')"
                    [class.is-invalid]="isFieldInvalid('adha_paka_kor')"
                    [class.is-valid]="isFieldValid('adha_paka_kor')">
                  <div class="invalid-feedback" *ngIf="isFieldInvalid('adha_paka_kor')">
                    সঠিক সংখ্যা লিখুন
                  </div>
                </div>
                <div class="tax-percentage" *ngIf="getTaxPercentage('adha_paka', 'adha_paka_kor') > 0">
                  <span class="percentage-info bangla-text">
                    <i class="fas fa-percent"></i>
                    কর হার: {{ getTaxPercentage('adha_paka', 'adha_paka_kor') }}%
                  </span>
                </div>
              </div>
            </div>

            <!-- Paka -->
            <div class="house-type-item" [class.has-value]="hasHouseTypeValue('paka')">
              <div class="house-type-header">
                <h4 class="bangla-title">পাকা</h4>
                <div class="type-status">
                  <span class="status-badge" 
                        [class.active]="hasHouseTypeValue('paka')"
                        [class.inactive]="!hasHouseTypeValue('paka')">
                    <i class="fas" [class.fa-check]="hasHouseTypeValue('paka')" 
                                   [class.fa-times]="!hasHouseTypeValue('paka')"></i>
                    {{ hasHouseTypeValue('paka') ? 'সক্রিয়' : 'নিষ্ক্রিয়' }}
                  </span>
                </div>
              </div>
              <div class="house-type-inputs">
                <div class="input-group">
                  <label class="bangla-label">
                    <i class="fas fa-tags"></i>
                    আনুমানিক মূল্য (টাকা)
                  </label>
                  <input 
                    type="text" 
                    class="form-control-modern number-input" 
                    formControlName="paka" 
                    placeholder="০"
                    (input)="formatCurrency($event, 'paka')"
                    [class.is-invalid]="isFieldInvalid('paka')"
                    [class.is-valid]="isFieldValid('paka')">
                  <div class="invalid-feedback" *ngIf="isFieldInvalid('paka')">
                    সঠিক সংখ্যা লিখুন
                  </div>
                </div>
                <div class="input-group">
                  <label class="bangla-label">
                    <i class="fas fa-receipt"></i>
                    ধার্যকৃত কর (টাকা)
                  </label>
                  <input 
                    type="text" 
                    class="form-control-modern number-input" 
                    formControlName="paka_kor" 
                    placeholder="০"
                    (input)="formatCurrency($event, 'paka_kor')"
                    [class.is-invalid]="isFieldInvalid('paka_kor')"
                    [class.is-valid]="isFieldValid('paka_kor')">
                  <div class="invalid-feedback" *ngIf="isFieldInvalid('paka_kor')">
                    সঠিক সংখ্যা লিখুন
                  </div>
                </div>
                <div class="tax-percentage" *ngIf="getTaxPercentage('paka', 'paka_kor') > 0">
                  <span class="percentage-info bangla-text">
                    <i class="fas fa-percent"></i>
                    কর হার: {{ getTaxPercentage('paka', 'paka_kor') }}%
                  </span>
                </div>
              </div>
            </div>

            <!-- Ek Tola -->
            <div class="house-type-item" [class.has-value]="hasHouseTypeValue('ek_tola')">
              <div class="house-type-header">
                <h4 class="bangla-title">এক তলা</h4>
                <div class="type-status">
                  <span class="status-badge" 
                        [class.active]="hasHouseTypeValue('ek_tola')"
                        [class.inactive]="!hasHouseTypeValue('ek_tola')">
                    <i class="fas" [class.fa-check]="hasHouseTypeValue('ek_tola')" 
                                   [class.fa-times]="!hasHouseTypeValue('ek_tola')"></i>
                    {{ hasHouseTypeValue('ek_tola') ? 'সক্রিয়' : 'নিষ্ক্রিয়' }}
                  </span>
                </div>
              </div>
              <div class="house-type-inputs">
                <div class="input-group">
                  <label class="bangla-label">
                    <i class="fas fa-tags"></i>
                    আনুমানিক মূল্য (টাকা)
                  </label>
                  <input 
                    type="text" 
                    class="form-control-modern number-input" 
                    formControlName="ek_tola" 
                    placeholder="০"
                    (input)="formatCurrency($event, 'ek_tola')"
                    [class.is-invalid]="isFieldInvalid('ek_tola')"
                    [class.is-valid]="isFieldValid('ek_tola')">
                  <div class="invalid-feedback" *ngIf="isFieldInvalid('ek_tola')">
                    সঠিক সংখ্যা লিখুন
                  </div>
                </div>
                <div class="input-group">
                  <label class="bangla-label">
                    <i class="fas fa-receipt"></i>
                    ধার্যকৃত কর (টাকা)
                  </label>
                  <input 
                    type="text" 
                    class="form-control-modern number-input" 
                    formControlName="ek_tola_kor" 
                    placeholder="০"
                    (input)="formatCurrency($event, 'ek_tola_kor')"
                    [class.is-invalid]="isFieldInvalid('ek_tola_kor')"
                    [class.is-valid]="isFieldValid('ek_tola_kor')">
                  <div class="invalid-feedback" *ngIf="isFieldInvalid('ek_tola_kor')">
                    সঠিক সংখ্যা লিখুন
                  </div>
                </div>
                <div class="tax-percentage" *ngIf="getTaxPercentage('ek_tola', 'ek_tola_kor') > 0">
                  <span class="percentage-info bangla-text">
                    <i class="fas fa-percent"></i>
                    কর হার: {{ getTaxPercentage('ek_tola', 'ek_tola_kor') }}%
                  </span>
                </div>
              </div>
            </div>

            <!-- Dui Tola -->
            <div class="house-type-item" [class.has-value]="hasHouseTypeValue('dui_tola')">
              <div class="house-type-header">
                <h4 class="bangla-title">দোতলা</h4>
                <div class="type-status">
                  <span class="status-badge" 
                        [class.active]="hasHouseTypeValue('dui_tola')"
                        [class.inactive]="!hasHouseTypeValue('dui_tola')">
                    <i class="fas" [class.fa-check]="hasHouseTypeValue('dui_tola')" 
                                   [class.fa-times]="!hasHouseTypeValue('dui_tola')"></i>
                    {{ hasHouseTypeValue('dui_tola') ? 'সক্রিয়' : 'নিষ্ক্রিয়' }}
                  </span>
                </div>
              </div>
              <div class="house-type-inputs">
                <div class="input-group">
                  <label class="bangla-label">
                    <i class="fas fa-tags"></i>
                    আনুমানিক মূল্য (টাকা)
                  </label>
                  <input 
                    type="text" 
                    class="form-control-modern number-input" 
                    formControlName="dui_tola" 
                    placeholder="০"
                    (input)="formatCurrency($event, 'dui_tola')"
                    [class.is-invalid]="isFieldInvalid('dui_tola')"
                    [class.is-valid]="isFieldValid('dui_tola')">
                  <div class="invalid-feedback" *ngIf="isFieldInvalid('dui_tola')">
                    সঠিক সংখ্যা লিখুন
                  </div>
                </div>
                <div class="input-group">
                  <label class="bangla-label">
                    <i class="fas fa-receipt"></i>
                    ধার্যকৃত কর (টাকা)
                  </label>
                  <input 
                    type="text" 
                    class="form-control-modern number-input" 
                    formControlName="dui_tola_kor" 
                    placeholder="০"
                    (input)="formatCurrency($event, 'dui_tola_kor')"
                    [class.is-invalid]="isFieldInvalid('dui_tola_kor')"
                    [class.is-valid]="isFieldValid('dui_tola_kor')">
                  <div class="invalid-feedback" *ngIf="isFieldInvalid('dui_tola_kor')">
                    সঠিক সংখ্যা লিখুন
                  </div>
                </div>
                <div class="tax-percentage" *ngIf="getTaxPercentage('dui_tola', 'dui_tola_kor') > 0">
                  <span class="percentage-info bangla-text">
                    <i class="fas fa-percent"></i>
                    কর হার: {{ getTaxPercentage('dui_tola', 'dui_tola_kor') }}%
                  </span>
                </div>
              </div>
            </div>

            <!-- Tin Tola -->
            <div class="house-type-item" [class.has-value]="hasHouseTypeValue('tin_tola')">
              <div class="house-type-header">
                <h4 class="bangla-title">তিনতলা</h4>
                <div class="type-status">
                  <span class="status-badge" 
                        [class.active]="hasHouseTypeValue('tin_tola')"
                        [class.inactive]="!hasHouseTypeValue('tin_tola')">
                    <i class="fas" [class.fa-check]="hasHouseTypeValue('tin_tola')" 
                                   [class.fa-times]="!hasHouseTypeValue('tin_tola')"></i>
                    {{ hasHouseTypeValue('tin_tola') ? 'সক্রিয়' : 'নিষ্ক্রিয়' }}
                  </span>
                </div>
              </div>
              <div class="house-type-inputs">
                <div class="input-group">
                  <label class="bangla-label">
                    <i class="fas fa-tags"></i>
                    আনুমানিক মূল্য (টাকা)
                  </label>
                  <input 
                    type="text" 
                    class="form-control-modern number-input" 
                    formControlName="tin_tola" 
                    placeholder="০"
                    (input)="formatCurrency($event, 'tin_tola')"
                    [class.is-invalid]="isFieldInvalid('tin_tola')"
                    [class.is-valid]="isFieldValid('tin_tola')">
                  <div class="invalid-feedback" *ngIf="isFieldInvalid('tin_tola')">
                    সঠিক সংখ্যা লিখুন
                  </div>
                </div>
                <div class="input-group">
                  <label class="bangla-label">
                    <i class="fas fa-receipt"></i>
                    ধার্যকৃত কর (টাকা)
                  </label>
                  <input 
                    type="text" 
                    class="form-control-modern number-input" 
                    formControlName="tin_tola_kor" 
                    placeholder="০"
                    (input)="formatCurrency($event, 'tin_tola_kor')"
                    [class.is-invalid]="isFieldInvalid('tin_tola_kor')"
                    [class.is-valid]="isFieldValid('tin_tola_kor')">
                  <div class="invalid-feedback" *ngIf="isFieldInvalid('tin_tola_kor')">
                    সঠিক সংখ্যা লিখুন
                  </div>
                </div>
                <div class="tax-percentage" *ngIf="getTaxPercentage('tin_tola', 'tin_tola_kor') > 0">
                  <span class="percentage-info bangla-text">
                    <i class="fas fa-percent"></i>
                    কর হার: {{ getTaxPercentage('tin_tola', 'tin_tola_kor') }}%
                  </span>
                </div>
              </div>
            </div>

            <!-- Char Tola -->
            <div class="house-type-item" [class.has-value]="hasHouseTypeValue('char_tola')">
              <div class="house-type-header">
                <h4 class="bangla-title">চারতলা</h4>
                <div class="type-status">
                  <span class="status-badge" 
                        [class.active]="hasHouseTypeValue('char_tola')"
                        [class.inactive]="!hasHouseTypeValue('char_tola')">
                    <i class="fas" [class.fa-check]="hasHouseTypeValue('char_tola')" 
                                   [class.fa-times]="!hasHouseTypeValue('char_tola')"></i>
                    {{ hasHouseTypeValue('char_tola') ? 'সক্রিয়' : 'নিষ্ক্রিয়' }}
                  </span>
                </div>
              </div>
              <div class="house-type-inputs">
                <div class="input-group">
                  <label class="bangla-label">
                    <i class="fas fa-tags"></i>
                    আনুমানিক মূল্য (টাকা)
                  </label>
                  <input 
                    type="text" 
                    class="form-control-modern number-input" 
                    formControlName="char_tola" 
                    placeholder="০"
                    (input)="formatCurrency($event, 'char_tola')"
                    [class.is-invalid]="isFieldInvalid('char_tola')"
                    [class.is-valid]="isFieldValid('char_tola')">
                  <div class="invalid-feedback" *ngIf="isFieldInvalid('char_tola')">
                    সঠিক সংখ্যা লিখুন
                  </div>
                </div>
                <div class="input-group">
                  <label class="bangla-label">
                    <i class="fas fa-receipt"></i>
                    ধার্যকৃত কর (টাকা)
                  </label>
                  <input 
                    type="text" 
                    class="form-control-modern number-input" 
                    formControlName="char_tola_kor" 
                    placeholder="০"
                    (input)="formatCurrency($event, 'char_tola_kor')"
                    [class.is-invalid]="isFieldInvalid('char_tola_kor')"
                    [class.is-valid]="isFieldValid('char_tola_kor')">
                  <div class="invalid-feedback" *ngIf="isFieldInvalid('char_tola_kor')">
                    সঠিক সংখ্যা লিখুন
                  </div>
                </div>
                <div class="tax-percentage" *ngIf="getTaxPercentage('char_tola', 'char_tola_kor') > 0">
                  <span class="percentage-info bangla-text">
                    <i class="fas fa-percent"></i>
                    কর হার: {{ getTaxPercentage('char_tola', 'char_tola_kor') }}%
                  </span>
                </div>
              </div>
            </div>

            <!-- Bohutol -->
            <div class="house-type-item" [class.has-value]="hasHouseTypeValue('bohutol')">
              <div class="house-type-header">
                <h4 class="bangla-title">বহুতল</h4>
                <div class="type-status">
                  <span class="status-badge" 
                        [class.active]="hasHouseTypeValue('bohutol')"
                        [class.inactive]="!hasHouseTypeValue('bohutol')">
                    <i class="fas" [class.fa-check]="hasHouseTypeValue('bohutol')" 
                                   [class.fa-times]="!hasHouseTypeValue('bohutol')"></i>
                    {{ hasHouseTypeValue('bohutol') ? 'সক্রিয়' : 'নিষ্ক্রিয়' }}
                  </span>
                </div>
              </div>
              <div class="house-type-inputs">
                <div class="input-group">
                  <label class="bangla-label">
                    <i class="fas fa-tags"></i>
                    আনুমানিক মূল্য (টাকা)
                  </label>
                  <input 
                    type="text" 
                    class="form-control-modern number-input" 
                    formControlName="bohutol" 
                    placeholder="০"
                    (input)="formatCurrency($event, 'bohutol')"
                    [class.is-invalid]="isFieldInvalid('bohutol')"
                    [class.is-valid]="isFieldValid('bohutol')">
                  <div class="invalid-feedback" *ngIf="isFieldInvalid('bohutol')">
                    সঠিক সংখ্যা লিখুন
                  </div>
                </div>
                <div class="input-group">
                  <label class="bangla-label">
                    <i class="fas fa-receipt"></i>
                    ধার্যকৃত কর (টাকা)
                  </label>
                  <input 
                    type="text" 
                    class="form-control-modern number-input" 
                    formControlName="bohutol_kor" 
                    placeholder="০"
                    (input)="formatCurrency($event, 'bohutol_kor')"
                    [class.is-invalid]="isFieldInvalid('bohutol_kor')"
                    [class.is-valid]="isFieldValid('bohutol_kor')">
                  <div class="invalid-feedback" *ngIf="isFieldInvalid('bohutol_kor')">
                    সঠিক সংখ্যা লিখুন
                  </div>
                </div>
                <div class="tax-percentage" *ngIf="getTaxPercentage('bohutol', 'bohutol_kor') > 0">
                  <span class="percentage-info bangla-text">
                    <i class="fas fa-percent"></i>
                    কর হার: {{ getTaxPercentage('bohutol', 'bohutol_kor') }}%
                  </span>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>

      <!-- SMS Configuration -->
      <div class="content-card slide-up">
        <div class="card-header">
          <h3 class="card-title bangla-title">
            <i class="fas fa-sms"></i>
            এসএমএস কনফিগারেশন
          </h3>
          <div class="card-actions">
            <span class="sms-status bangla-text">
              <i class="fas fa-broadcast-tower"></i>
              {{ getActiveSMSCount() }} টি এসএমএস সক্রিয়
            </span>
          </div>
        </div>
        
        <div class="card-body">
          <div class="sms-help" *ngIf="editUnion">
            <div class="help-content">
              <i class="fas fa-info-circle"></i>
              <div class="bangla-text">
                <strong>এসএমএস গাইড:</strong> ভেরিয়েবল ব্যবহার করে ডায়নামিক এসএমএস তৈরি করুন। 
                এসএমএস ১৬০ অক্ষরের মধ্যে রাখার চেষ্টা করুন। ভেরিয়েবল ব্যবহারের জন্য নিচের রেফারেন্স দেখুন।
              </div>
            </div>
          </div>

          <div class="sms-configs">
            
            <!-- Assessment SMS -->
            <div class="sms-config-item">
              <div class="sms-header">
                <div class="sms-title-section">
                  <h4 class="bangla-title">এ্যাসেসমেন্ট আবেদন SMS</h4>
                  <p class="sms-description">নতুন এ্যাসেসমেন্ট তৈরি হলে গৃহস্থের কাছে পাঠানো হবে</p>
                </div>
                <div class="toggle-section">
                  <div class="toggle-switch">
                    <input 
                      type="checkbox" 
                      class="toggle-input" 
                      id="assessment_sms_toggle"
                      formControlName="is_create_assessment_msg_on">
                    <label for="assessment_sms_toggle" class="toggle-label">
                      <span class="toggle-slider"></span>
                      <span class="toggle-text bangla-label">
                        {{ unionFrom.get('is_create_assessment_msg_on')?.value ? 'চালু' : 'বন্ধ' }}
                      </span>
                    </label>
                  </div>
                </div>
              </div>
              <div class="sms-content">
                <div class="textarea-wrapper">
                  <textarea 
                    rows="4" 
                    class="form-control-modern sms-textarea" 
                    formControlName="create_assessment_msg"
                    placeholder="এ্যাসেসমেন্ট আবেদনের জন্য SMS টেমপ্লেট লিখুন..."
                    maxlength="500"
                    (input)="updateCharacterCount('assessment')"
                    [class.is-invalid]="isFieldInvalid('create_assessment_msg')"
                    [class.is-valid]="isFieldValid('create_assessment_msg')"></textarea>
                  <div class="textarea-footer">
                    <div class="character-count">
                      <span class="count-info" 
                            [class.warning]="getCharacterCount('create_assessment_msg') > 160"
                            [class.danger]="getCharacterCount('create_assessment_msg') > 300">
                        {{ getCharacterCount('create_assessment_msg') }}/500 অক্ষর
                      </span>
                      <span class="sms-count" *ngIf="getCharacterCount('create_assessment_msg') > 0">
                        ({{ getSMSCount('create_assessment_msg') }} টি এসএমএস)
                      </span>
                    </div>
                    <button type="button" 
                            class="btn-preview"
                            *ngIf="unionFrom.get('create_assessment_msg')?.value && editUnion"
                            (click)="previewSMS('assessment')">
                      <i class="fas fa-eye"></i>
                      প্রিভিউ
                    </button>
                  </div>
                </div>
                <div class="invalid-feedback" *ngIf="isFieldInvalid('create_assessment_msg')">
                  এসএমএস টেমপ্লেট সঠিক নয়
                </div>
                
                <!-- SMS Preview -->
                <div class="sms-preview" *ngIf="showPreview.assessment">
                  <div class="preview-header">
                    <h5 class="bangla-text">
                      <i class="fas fa-mobile-alt"></i>
                      এসএমএস প্রিভিউ
                    </h5>
                    <button type="button" class="close-preview" (click)="closePreview('assessment')">
                      <i class="fas fa-times"></i>
                    </button>
                  </div>
                  <div class="preview-content">
                    <div class="phone-mockup">
                      <div class="sms-bubble">
                        {{ getPreviewText('create_assessment_msg') }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Tax Collection SMS -->
            <div class="sms-config-item">
              <div class="sms-header">
                <div class="sms-title-section">
                  <h4 class="bangla-title">কর আদায় SMS</h4>
                  <p class="sms-description">কর আদায়ের পর গৃহস্থের কাছে রশিদ পাঠানো হবে</p>
                </div>
                <div class="toggle-section">
                  <div class="toggle-switch">
                    <input 
                      type="checkbox" 
                      class="toggle-input" 
                      id="tax_collection_sms_toggle"
                      formControlName="is_tax_collection_msg_on">
                    <label for="tax_collection_sms_toggle" class="toggle-label">
                      <span class="toggle-slider"></span>
                      <span class="toggle-text bangla-label">
                        {{ unionFrom.get('is_tax_collection_msg_on')?.value ? 'চালু' : 'বন্ধ' }}
                      </span>
                    </label>
                  </div>
                </div>
              </div>
              <div class="sms-content">
                <div class="textarea-wrapper">
                  <textarea 
                    rows="4" 
                    class="form-control-modern sms-textarea" 
                    formControlName="tax_collection_msg"
                    placeholder="কর আদায়ের জন্য SMS টেমপ্লেট লিখুন..."
                    maxlength="500"
                    (input)="updateCharacterCount('tax')"
                    [class.is-invalid]="isFieldInvalid('tax_collection_msg')"
                    [class.is-valid]="isFieldValid('tax_collection_msg')"></textarea>
                  <div class="textarea-footer">
                    <div class="character-count">
                      <span class="count-info" 
                            [class.warning]="getCharacterCount('tax_collection_msg') > 160"
                            [class.danger]="getCharacterCount('tax_collection_msg') > 300">
                        {{ getCharacterCount('tax_collection_msg') }}/500 অক্ষর
                      </span>
                      <span class="sms-count" *ngIf="getCharacterCount('tax_collection_msg') > 0">
                        ({{ getSMSCount('tax_collection_msg') }} টি এসএমএস)
                      </span>
                    </div>
                    <button type="button" 
                            class="btn-preview"
                            *ngIf="unionFrom.get('tax_collection_msg')?.value && editUnion"
                            (click)="previewSMS('tax')">
                      <i class="fas fa-eye"></i>
                      প্রিভিউ
                    </button>
                  </div>
                </div>
                <div class="invalid-feedback" *ngIf="isFieldInvalid('tax_collection_msg')">
                  এসএমএস টেমপ্লেট সঠিক নয়
                </div>
                
                <!-- SMS Preview -->
                <div class="sms-preview" *ngIf="showPreview.tax">
                  <div class="preview-header">
                    <h5 class="bangla-text">
                      <i class="fas fa-mobile-alt"></i>
                      এসএমএস প্রিভিউ
                    </h5>
                    <button type="button" class="close-preview" (click)="closePreview('tax')">
                      <i class="fas fa-times"></i>
                    </button>
                  </div>
                  <div class="preview-content">
                    <div class="phone-mockup">
                      <div class="sms-bubble">
                        {{ getPreviewText('tax_collection_msg') }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>

      <!-- SMS Variables Reference -->
      <div class="content-card slide-up">
        <div class="card-header">
          <h3 class="card-title bangla-title">
            <i class="fas fa-code"></i>
            SMS ভেরিয়েবল রেফারেন্স
          </h3>
          <div class="card-actions">
            <div class="variable-search">
              <input 
                type="text" 
                class="search-input" 
                [(ngModel)]="variableSearchTerm"
                placeholder="ভেরিয়েবল খুঁজুন..."
                (input)="filterVariables()">
              <i class="fas fa-search search-icon"></i>
            </div>
            <span class="variables-count bangla-text">
              <i class="fas fa-hashtag"></i>
              {{ getVisibleVariablesCount() }} টি ভেরিয়েবল
            </span>
          </div>
        </div>
        
        <div class="card-body">
          <div class="variables-help">
            <div class="help-content">
              <i class="fas fa-lightbulb"></i>
              <div class="bangla-text">
                <strong>ভেরিয়েবল ব্যবহার:</strong> SMS টেমপ্লেটে ডায়নামিক তথ্য যোগ করতে এই ভেরিয়েবলগুলো ব্যবহার করুন। 
                ভেরিয়েবল কপি করতে তার উপর ক্লিক করুন।
              </div>
            </div>
          </div>

          <div class="variables-grid">
            
            <div class="variable-category" *ngIf="shouldShowCategory('tax')">
              <div class="category-header">
                <h4 class="bangla-title">
                  <i class="fas fa-money-bill-wave"></i>
                  কর সংক্রান্ত
                </h4>
                <span class="category-count">{{ getFilteredVariables('tax').length }} টি</span>
              </div>
              <div class="variable-list">
                <div class="variable-item" 
                     *ngFor="let variable of getFilteredVariables('tax')"
                     (click)="copyToClipboard(variable.code, variable.label)"
                     [class.copied]="recentlyCopied === variable.code">
                  <div class="variable-code">
                    <code ngNonBindable>{{ variable.code }}</code>
                    <i class="fas fa-copy copy-icon"></i>
                  </div>
                  <span class="bangla-text variable-description">{{ variable.label }}</span>
                </div>
              </div>
            </div>

            <div class="variable-category" *ngIf="shouldShowCategory('assessment')">
              <div class="category-header">
                <h4 class="bangla-title">
                  <i class="fas fa-file-invoice"></i>
                  এ্যাসেসমেন্ট তথ্য
                </h4>
                <span class="category-count">{{ getFilteredVariables('assessment').length }} টি</span>
              </div>
              <div class="variable-list">
                <div class="variable-item" 
                     *ngFor="let variable of getFilteredVariables('assessment')"
                     (click)="copyToClipboard(variable.code, variable.label)"
                     [class.copied]="recentlyCopied === variable.code">
                  <div class="variable-code">
                    <code ngNonBindable>{{ variable.code }}</code>
                    <i class="fas fa-copy copy-icon"></i>
                  </div>
                  <span class="bangla-text variable-description">{{ variable.label }}</span>
                </div>
              </div>
            </div>

            <div class="variable-category" *ngIf="shouldShowCategory('union')">
              <div class="category-header">
                <h4 class="bangla-title">
                  <i class="fas fa-landmark"></i>
                  ইউনিয়ন তথ্য
                </h4>
                <span class="category-count">{{ getFilteredVariables('union').length }} টি</span>
              </div>
              <div class="variable-list">
                <div class="variable-item" 
                     *ngFor="let variable of getFilteredVariables('union')"
                     (click)="copyToClipboard(variable.code, variable.label)"
                     [class.copied]="recentlyCopied === variable.code">
                  <div class="variable-code">
                    <code ngNonBindable>{{ variable.code }}</code>
                    <i class="fas fa-copy copy-icon"></i>
                  </div>
                  <span class="bangla-text variable-description">{{ variable.label }}</span>
                </div>
              </div>
            </div>

          </div>

          <!-- No Results Message -->
          <div class="no-results" *ngIf="getVisibleVariablesCount() === 0 && variableSearchTerm">
            <div class="no-results-content">
              <i class="fas fa-search"></i>
              <h4 class="bangla-title">কোনো ভেরিয়েবল পাওয়া যায়নি</h4>
              <p class="bangla-text">
                "{{ variableSearchTerm }}" এর জন্য কোনো ভেরিয়েবল খুঁজে পাওয়া যায়নি। 
                অনুসন্ধান শব্দ পরিবর্তন করে আবার চেষ্টা করুন।
              </p>
              <button type="button" class="btn-clear-search" (click)="clearSearch()">
                <i class="fas fa-times"></i>
                অনুসন্ধান সাফ করুন
              </button>
            </div>
          </div>

          <!-- Copy Success Toast -->
          <div class="copy-toast" [class.show]="showCopyToast">
            <div class="toast-content">
              <i class="fas fa-check"></i>
              <span class="bangla-text">{{ lastCopiedVariable }} কপি করা হয়েছে!</span>
            </div>
          </div>
        </div>
      </div>

    </form>
  </div>
</div>